import { Plan } from "@WahooFitness/redesignr";

export enum EventType {
  click = "click",
  dismiss = "dismiss",
}

export enum ClickTarget {
  activate_subscription = "activate_subscription_button",
  athlete_profile = "athlete_profile",
  athlete_profile_cycling = "athlete_profile_cycling",
  athlete_profile_running = "athlete_profile_running",
  back = "back_button",
  cancel_subscription = "cancel_subscription_button",
  close = "close_button",
  continue = "continue_button",
  discard_results = "discard_results_button",
  estimate_chip = "estimate_chip",
  manual_chip = "manual_chip",
  fitness_assessment = "fitness_assessment",
  historical_fitness_profile = "historical_fitness_profile_card",
  how_we_calculate = "how_we_calculate_button",
  manage_subscription = "manage_subscription_button",
  my_subscription = "my_subscription_button",
  next = "next_button",
  question_icon = "question_icon",
  resubscribe = "resubscribe_button",
  retake_fitness_assessment = "retake_fitness_assessment",
  rider_type_mismatch_alert = "rider_type_mismatch_alert",
  save = "save_button",
  see_results = "see_results_button",
  start_questionnaire = "start_questionnaire",
  start_quiz = "start_quiz",
  start_trial = "start_trial_button",
  update_manually = "update_manually_button",
  view_historical_fitness_profiles = "view_historical_fitness_profiles",
  view_workout_details = "view_workout_details",
  daily_mental_check_in_enabled = "daily_mental_check_in_enabled",
  daily_mental_check_in_disabled = "daily_mental_check_in_disabled",
  cycling_tab = "cycling_tab",
  running_tab = "running_tab",
  edit_tabs = "edit_tabs",
  education = "education",
  update_profile = "update_profile",
  strength = "strength",
  weakness = "weakness",
  estimate = "estimate",
  paywall_plan_pro = "pro",
  paywall_plan_core = "core",
  paywall_plan_base = "base",
  paywall_start_trial = "start_trial",
  paywall_upgrade = "upgrade",
  change_plan = "change_plan_button",
  downgrade = "downgrade_button",
  systm_app = "systm_app_link",
  keep_subscription = "keep_subscription_button",
  toggle_on = "toggle_on",
  toggle_off = "toggle_off",
  request_it = "request_it",
}

export enum SourcePage {
  athlete_profile_cycling = "athlete_profile_cycling",
  athlete_profile_running = "athlete_profile_running",
  fitness_profile = "fitness_profile",
  fourdp_quiz = "fourdp_quiz",
  fourdp_quiz_results = "fourdp_quiz_results",
  fourdp_quiz_powerzones = "fourdp_quiz_powerzones",
  settings = "settings",
  fourdp_education = "fourdp_education",
  threedp_quiz = "threedp_quiz",
  threedp_quiz_results = "threedp_quiz_results",
  my_subscription = "my_subscription",
  fourdp_manual_update = "fourdp_manual_update",
  fourdp_manual_update_powerzones = "fourdp_manual_update_powerzones",
  historical_fitness_profiles = "historical_fitness_profiles",
  mental_training_preferences = "mental_training_preferences",
  threedp_education = "threedp_education",
  pro_paywall = "pro_paywall",
  core_paywall = "core_paywall",
  change_plan = "change_plan",
  notifications = "notifications",
  workout_profile_pages = "workout_profile_pages",
  authorized_apps = "authorized_apps",
  request_wearables = "request_wearables",
}

export type Event = {
  event_type: EventType;
  click_target?: ClickTarget;
  source_page_name: SourcePage;
  component_app_id: number;
  fitness_app_id: number;
  referrer?: string;
};

export type StepperEvent = Event & {
  step_name?: string;
  step_ordering: number;
};

export type AnyEvent = StepperEvent;

export const PLAN_CLICK_TARGET: Record<Plan, ClickTarget> = {
  pro: ClickTarget.paywall_plan_pro,
  core: ClickTarget.paywall_plan_core,
  base: ClickTarget.paywall_plan_base,
};
